import { Button } from "components/DesignSystem/Button/Button";
import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";
import { Refresh } from "components/icons/Refresh";
import { VarianceExplanation } from "types/Models/report";
import { CitedEntityChip } from "./CitedEntityChip";

type VarianceExplanationContentProps = {
  isLoading: boolean;
  isError: boolean;
  explanation?: VarianceExplanation;
  onRetry: () => void;
};

export const VarianceExplanationContent = ({
  isLoading,
  isError,
  explanation,
  onRetry,
}: VarianceExplanationContentProps) => {
  if (isLoading) {
    return (
      <div className="t-flex t-flex-col t-gap-2 t-py-1">
        <Skeleton className="t-h-3 t-w-full" />
        <Skeleton className="t-h-3 t-w-2/3" />
      </div>
    );
  }

  if (isError && !explanation?.description) {
    return (
      <div className="t-flex t-items-center t-justify-between t-gap-2">
        <span className="t-text-body-sm t-italic t-text-red">
          - Couldn&apos;t generate -
        </span>
        <Button customType="link_neutral" size="small" onClick={onRetry}>
          <div className="t-flex t-justify-between t-items-center  t-gap-1">
            <span style={{ transform: "scaleX(-1)" }}>
              <Refresh size="12" stroke="1.2" />
            </span>
            Retry
          </div>
        </Button>
      </div>
    );
  }

  if (!explanation) return null;

  return (
    <div className="t-flex t-flex-col t-gap-2">
      <p className="t-m-0 t-text-body-sm t-text-text-100">
        {explanation.description}
      </p>
    </div>
  );
};
